module.exports = __webpack_public_path__ + "img/1F1EE-1F1F1.f85695e0.svg";